module.exports = __webpack_public_path__ + "static/media/unpaid-balance-confirm.d01faffe.gif";